// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DataBlockType, DataBlockTypeT, verifyDataBlockType } from "./data-block-type";
import { Offset, OffsetT, verifyOffset } from "./offset";
import { OffsetType, OffsetTypeT, verifyOffsetType } from "./offset-type";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Data block — a logical grouping of offsets within a configuration.
 */
export class DataBlock implements flatbuffers.IUnpackableObject<DataBlockT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): DataBlock {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsDataBlock(bb: flatbuffers.ByteBuffer, obj?: DataBlock): DataBlock {
    return (obj || new DataBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsDataBlock(bb: flatbuffers.ByteBuffer, obj?: DataBlock): DataBlock {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new DataBlock()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  configurationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  dataBlockTypeId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Nested offsets for this data block (populated on detail endpoints).
   */
  offsets(index: number, obj?: Offset): Offset | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset
      ? (obj || new Offset()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Nested data block type (populated on detail endpoints).
   */
  dataBlockType(obj?: DataBlockType): DataBlockType | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset
      ? (obj || new DataBlockType()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * Nested offset types associated with this data block (populated on detail endpoints).
   */
  offsetTypes(index: number, obj?: OffsetType): OffsetType | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? (obj || new OffsetType()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetTypesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Bank ids to ATTACH to this data block (many2many). Mirrors
   * models.DataBlockReq.Banks (`json:"banks"`). Named bank_ids, NOT
   * banks, because models.DataBlock (the GET response this table also
   * represents) preloads a `Banks []*Bank` association under that exact
   * same json tag (data-block.model.go:17) — same collision-avoidance
   * rule as offset_type_ids below.
   *
   * Appended at the end of the table to preserve `FlatBuffer` wire
   * compatibility — never insert fields in the middle.
   */
  bankIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Bank ids to DETACH. Mirrors DataBlockReq.Banks2Delete (`json:"banks2delete"`).
   * Suffixed _ids for the same reason as bank_ids above.
   */
  bankIds2delete(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankIds2deleteLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Offset-type ids to ATTACH (many2many). Named offset_type_ids, NOT
   * offset_types, because this table already has a nested response
   * field called offset_types ([OffsetType] above) — a duplicate field
   * name in one table is illegal. Mirrors DataBlockReq.OffsetTypes
   * (`json:"offset_types"`); the unpack function maps this FB field to
   * that Go field by position, not by name.
   */
  offsetTypeIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetTypeIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Offset-type ids to DETACH. Mirrors DataBlockReq.OffsetTypes2Delete
   * (`json:"offset_types2delete"`).
   */
  offsetTypeIds2delete(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  offsetTypeIds2deleteLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startDataBlock(builder: flatbuffers.Builder) {
    builder.startObject(13);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addConfigurationId(
    builder: flatbuffers.Builder,
    configurationIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(1, configurationIdOffset, 0);
  }

  static addDataBlockTypeId(
    builder: flatbuffers.Builder,
    dataBlockTypeIdOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, dataBlockTypeIdOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, deletedAtOffset, 0);
  }

  static addOffsets(builder: flatbuffers.Builder, offsetsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(6, offsetsOffset, 0);
  }

  static createOffsetsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addDataBlockType(builder: flatbuffers.Builder, dataBlockTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, dataBlockTypeOffset, 0);
  }

  static addOffsetTypes(builder: flatbuffers.Builder, offsetTypesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, offsetTypesOffset, 0);
  }

  static createOffsetTypesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetTypesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankIds(builder: flatbuffers.Builder, bankIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, bankIdsOffset, 0);
  }

  static createBankIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankIds2delete(builder: flatbuffers.Builder, bankIds2deleteOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, bankIds2deleteOffset, 0);
  }

  static createBankIds2deleteVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankIds2deleteVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOffsetTypeIds(builder: flatbuffers.Builder, offsetTypeIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, offsetTypeIdsOffset, 0);
  }

  static createOffsetTypeIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetTypeIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOffsetTypeIds2delete(
    builder: flatbuffers.Builder,
    offsetTypeIds2deleteOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(12, offsetTypeIds2deleteOffset, 0);
  }

  static createOffsetTypeIds2deleteVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOffsetTypeIds2deleteVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endDataBlock(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): DataBlockT {
    return new DataBlockT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.configurationId() !== null ? this.configurationId()!.unpack() : null,
      this.dataBlockTypeId() !== null ? this.dataBlockTypeId()!.unpack() : null,
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<Offset, OffsetT>(this.offsets.bind(this), this.offsetsLength()),
      this.dataBlockType() !== null ? this.dataBlockType()!.unpack() : null,
      this.bb!.createObjList<OffsetType, OffsetTypeT>(
        this.offsetTypes.bind(this),
        this.offsetTypesLength(),
      ),
      this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength()),
      this.bb!.createObjList<Uuid, UuidT>(
        this.bankIds2delete.bind(this),
        this.bankIds2deleteLength(),
      ),
      this.bb!.createObjList<Uuid, UuidT>(
        this.offsetTypeIds.bind(this),
        this.offsetTypeIdsLength(),
      ),
      this.bb!.createObjList<Uuid, UuidT>(
        this.offsetTypeIds2delete.bind(this),
        this.offsetTypeIds2deleteLength(),
      ),
    );
  }

  unpackTo(_o: DataBlockT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.configurationId = this.configurationId() !== null ? this.configurationId()!.unpack() : null;
    _o.dataBlockTypeId = this.dataBlockTypeId() !== null ? this.dataBlockTypeId()!.unpack() : null;
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.offsets = this.bb!.createObjList<Offset, OffsetT>(
      this.offsets.bind(this),
      this.offsetsLength(),
    );
    _o.dataBlockType = this.dataBlockType() !== null ? this.dataBlockType()!.unpack() : null;
    _o.offsetTypes = this.bb!.createObjList<OffsetType, OffsetTypeT>(
      this.offsetTypes.bind(this),
      this.offsetTypesLength(),
    );
    _o.bankIds = this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength());
    _o.bankIds2delete = this.bb!.createObjList<Uuid, UuidT>(
      this.bankIds2delete.bind(this),
      this.bankIds2deleteLength(),
    );
    _o.offsetTypeIds = this.bb!.createObjList<Uuid, UuidT>(
      this.offsetTypeIds.bind(this),
      this.offsetTypeIdsLength(),
    );
    _o.offsetTypeIds2delete = this.bb!.createObjList<Uuid, UuidT>(
      this.offsetTypeIds2delete.bind(this),
      this.offsetTypeIds2deleteLength(),
    );
  }

  unpackFields(...fields: string[]): DataBlockT {
    const t = new DataBlockT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("configuration_id")) {
      t.configurationId = this.configurationId() !== null ? this.configurationId()!.unpack() : null;
    }
    if (fieldSet.has("data_block_type_id")) {
      t.dataBlockTypeId = this.dataBlockTypeId() !== null ? this.dataBlockTypeId()!.unpack() : null;
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("offsets")) {
      t.offsets = this.bb!.createObjList<Offset, OffsetT>(
        this.offsets.bind(this),
        this.offsetsLength(),
      );
    }
    if (fieldSet.has("data_block_type")) {
      t.dataBlockType = this.dataBlockType() !== null ? this.dataBlockType()!.unpack() : null;
    }
    if (fieldSet.has("offset_types")) {
      t.offsetTypes = this.bb!.createObjList<OffsetType, OffsetTypeT>(
        this.offsetTypes.bind(this),
        this.offsetTypesLength(),
      );
    }
    if (fieldSet.has("bank_ids")) {
      t.bankIds = this.bb!.createObjList<Uuid, UuidT>(
        this.bankIds.bind(this),
        this.bankIdsLength(),
      );
    }
    if (fieldSet.has("bank_ids_2delete")) {
      t.bankIds2delete = this.bb!.createObjList<Uuid, UuidT>(
        this.bankIds2delete.bind(this),
        this.bankIds2deleteLength(),
      );
    }
    if (fieldSet.has("offset_type_ids")) {
      t.offsetTypeIds = this.bb!.createObjList<Uuid, UuidT>(
        this.offsetTypeIds.bind(this),
        this.offsetTypeIdsLength(),
      );
    }
    if (fieldSet.has("offset_type_ids_2delete")) {
      t.offsetTypeIds2delete = this.bb!.createObjList<Uuid, UuidT>(
        this.offsetTypeIds2delete.bind(this),
        this.offsetTypeIds2deleteLength(),
      );
    }
    return t;
  }
}

export class DataBlockT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public configurationId: UuidT | null = null,
    public dataBlockTypeId: UuidT | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public offsets: OffsetT[] = [],
    public dataBlockType: DataBlockTypeT | null = null,
    public offsetTypes: OffsetTypeT[] = [],
    public bankIds: UuidT[] = [],
    public bankIds2delete: UuidT[] = [],
    public offsetTypeIds: UuidT[] = [],
    public offsetTypeIds2delete: UuidT[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const configurationId = this.configurationId !== null ? this.configurationId!.pack(builder) : 0;
    const dataBlockTypeId = this.dataBlockTypeId !== null ? this.dataBlockTypeId!.pack(builder) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const offsets = DataBlock.createOffsetsVector(
      builder,
      builder.createObjectOffsetList(this.offsets),
    );
    const dataBlockType = this.dataBlockType !== null ? this.dataBlockType!.pack(builder) : 0;
    const offsetTypes = DataBlock.createOffsetTypesVector(
      builder,
      builder.createObjectOffsetList(this.offsetTypes),
    );
    const bankIds = DataBlock.createBankIdsVector(
      builder,
      builder.createObjectOffsetList(this.bankIds),
    );
    const bankIds2delete = DataBlock.createBankIds2deleteVector(
      builder,
      builder.createObjectOffsetList(this.bankIds2delete),
    );
    const offsetTypeIds = DataBlock.createOffsetTypeIdsVector(
      builder,
      builder.createObjectOffsetList(this.offsetTypeIds),
    );
    const offsetTypeIds2delete = DataBlock.createOffsetTypeIds2deleteVector(
      builder,
      builder.createObjectOffsetList(this.offsetTypeIds2delete),
    );

    DataBlock.startDataBlock(builder);
    DataBlock.addId(builder, id);
    DataBlock.addConfigurationId(builder, configurationId);
    DataBlock.addDataBlockTypeId(builder, dataBlockTypeId);
    DataBlock.addCreatedAt(builder, createdAt);
    DataBlock.addUpdatedAt(builder, updatedAt);
    DataBlock.addDeletedAt(builder, deletedAt);
    DataBlock.addOffsets(builder, offsets);
    DataBlock.addDataBlockType(builder, dataBlockType);
    DataBlock.addOffsetTypes(builder, offsetTypes);
    DataBlock.addBankIds(builder, bankIds);
    DataBlock.addBankIds2delete(builder, bankIds2delete);
    DataBlock.addOffsetTypeIds(builder, offsetTypeIds);
    DataBlock.addOffsetTypeIds2delete(builder, offsetTypeIds2delete);

    return DataBlock.endDataBlock(builder);
  }

  clone(): DataBlockT {
    const obj = new DataBlockT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.configurationId = this.configurationId !== null ? this.configurationId!.clone() : null;
    obj.dataBlockTypeId = this.dataBlockTypeId !== null ? this.dataBlockTypeId!.clone() : null;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.offsets = this.offsets.map((e) => e.clone());
    obj.dataBlockType = this.dataBlockType !== null ? this.dataBlockType!.clone() : null;
    obj.offsetTypes = this.offsetTypes.map((e) => e.clone());
    obj.bankIds = this.bankIds.map((e) => e.clone());
    obj.bankIds2delete = this.bankIds2delete.map((e) => e.clone());
    obj.offsetTypeIds = this.offsetTypeIds.map((e) => e.clone());
    obj.offsetTypeIds2delete = this.offsetTypeIds2delete.map((e) => e.clone());
    return obj;
  }

  equals(other: DataBlockT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.configurationId !== null && other.configurationId !== null) {
      if (!this.configurationId!.equals(other.configurationId!)) return false;
    } else if (this.configurationId !== other.configurationId) return false;
    if (this.dataBlockTypeId !== null && other.dataBlockTypeId !== null) {
      if (!this.dataBlockTypeId!.equals(other.dataBlockTypeId!)) return false;
    } else if (this.dataBlockTypeId !== other.dataBlockTypeId) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.offsets.length !== other.offsets.length) return false;
    for (let i = 0; i < this.offsets.length; i++) {
      const a = this.offsets[i];
      const b = other.offsets[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.dataBlockType !== null && other.dataBlockType !== null) {
      if (!this.dataBlockType!.equals(other.dataBlockType!)) return false;
    } else if (this.dataBlockType !== other.dataBlockType) return false;
    if (this.offsetTypes.length !== other.offsetTypes.length) return false;
    for (let i = 0; i < this.offsetTypes.length; i++) {
      const a = this.offsetTypes[i];
      const b = other.offsetTypes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankIds.length !== other.bankIds.length) return false;
    for (let i = 0; i < this.bankIds.length; i++) {
      const a = this.bankIds[i];
      const b = other.bankIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankIds2delete.length !== other.bankIds2delete.length) return false;
    for (let i = 0; i < this.bankIds2delete.length; i++) {
      const a = this.bankIds2delete[i];
      const b = other.bankIds2delete[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.offsetTypeIds.length !== other.offsetTypeIds.length) return false;
    for (let i = 0; i < this.offsetTypeIds.length; i++) {
      const a = this.offsetTypeIds[i];
      const b = other.offsetTypeIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.offsetTypeIds2delete.length !== other.offsetTypeIds2delete.length) return false;
    for (let i = 0; i < this.offsetTypeIds2delete.length; i++) {
      const a = this.offsetTypeIds2delete[i];
      const b = other.offsetTypeIds2delete[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyDataBlock(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 18);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyDataBlockType(verifier, fieldPos + tableOffset);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOffsetType);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
